'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicCommon = require('@gig/magic-common');
var jurisdictions_constants = require('../jurisdictions.constants.js');
var magicMessaging = require('@gig/magic-messaging');

function getWelcomeNotificationParams(jurisdiction, loginHistory) {
  switch (jurisdiction) {
    case jurisdictions_constants.Jurisdiction.AGCO: {
      if (isFirstLogin(loginHistory)) {
        return {};
      }
      const loginTime = magicCommon.convertToDate(`${loginHistory[1].dateCreated}Z`);
      return {
        lastVisitDate: magicCommon.formatDate(loginTime),
        lastVisitTime: magicCommon.formatTime(loginTime)
      };
    }
    default: {
      return {};
    }
  }
}
function getWelcomeNotificationKey(jurisdiction, loginHistory) {
  switch (jurisdiction) {
    case jurisdictions_constants.Jurisdiction.AGCO: {
      if (isFirstLogin(loginHistory)) {
        return "login.welcome-notification-limits";
      }
      return "login.welcome-notification-time";
    }
    default: {
      return "login.welcome-notification";
    }
  }
}
function getWelcomeNotificationOptions(jurisdiction, loginHistory) {
  switch (jurisdiction) {
    case jurisdictions_constants.Jurisdiction.AGCO: {
      if (isFirstLogin(loginHistory)) {
        return { closeDelay: magicMessaging.NotificationDelay.PERMANENT };
      }
      return {};
    }
    default: {
      return {};
    }
  }
}
function isFirstLogin(loginHistory) {
  return loginHistory.length !== 2;
}

exports.getWelcomeNotificationKey = getWelcomeNotificationKey;
exports.getWelcomeNotificationOptions = getWelcomeNotificationOptions;
exports.getWelcomeNotificationParams = getWelcomeNotificationParams;
